import {Link} from "@tanstack/react-router";
import LiveAuctionsItem from './LiveAuctionsItem'
import ITag from '../ITag'
import data from '../../data/data-components/data-SecLiveAuctions.js'
import {useEffect, useState} from "react";
import { getListingsByMeta } from '../../lib/api';


//let wsIsInit = false;

//let defInterval = 1000;

let lastType = "";

let enws = false;
let timer=200;
/**
 * SecLiveAuctions - Grid of live auction listings
 *
 * Fetches and displays currently auctioned NFTs via Backend('listingsByMeta').
 * Renders each item using LiveAuctionsItem component. Includes a "Load More"
 * button (currently static link to home).
 *
 * Can receive initial data via props for SSR (loader pattern).
 *
 * Note: Contains commented WebSocket implementation for real-time updates.
 *
 * @param {Object} props
 * @param {string} props.lType - Auction type filter (currently unused)
 * @param {Array} props.initialAuctions - Optional preloaded auction data from route loader
 * @returns {React.ReactElement} Rendered live auctions grid
 */
function SecLiveAuctions({lType, initialAuctions}) {

    //let bob;

    const [wsObj, swsObj] = useState(initialAuctions || null);
//    const [updateSpeed, setUs] = useState(1000)
    const [ic, icp] = useState(0);
    const [iv1, siv1] = useState(null);
    const [aa, saa] = useState()

    useEffect( ()=>{

        enws = true;

        // Only fetch if no initial data provided
        if (!initialAuctions) {
            getData();
        } else {
            swsObj(initialAuctions);
        }

        return ()=> {
            clearInterval(aa)
            saa(null)
            enws=false;
        }
    }, [])

    const getData = async () => {
        try {
            const result = await getListingsByMeta();
            swsObj(result.data);
        } catch (error) {
            console.error('Failed to fetch live auctions:', error);
            swsObj([]);
        }
        // console.log("checking for websocket");
        // if (window.hasOwnProperty("wsavail") && enws) {
        //
        //     console.log("WS:", window.wsavail)
        //     try {
        //
        //         window.genws.send('{"reqType": "LiveAuctions", "type": "'+lType+'"}');
        //
        //         //if(defInterval<15000) {
        //         window.genws.onmessage = (e) => {
        //             //    alert(e.data)
        //             lastType = lType;
        //             if (e.data.includes("aImageURI")) {
        //                 try {
        //                     let obj = JSON.parse(e.data);
        //                     console.log(obj)
        //                     if (!obj.hasOwnProperty("error")) {
        //                         // event name
        //                         console.log(obj.event);
        //
        //                         // event data
        //                         console.log(obj.value, typeof obj);
        //
        //
        //                         //   _bids = { ...bids, ...obj}
        //                         let objectArray = Object.entries(obj);
        //                         // for (let i = 0; i < objectArray.length; i++) {
        //                         //     let tmpData = JSON.parse(objectArray[i][1].mData);
        //                         //     delete (objectArray[i][1].mData)
        //                         //     objectArray[i][2] = tmpData
        //                         //     console.log(objectArray[i])
        //                         // }
        //                         ///wsObj.map()
        //                         swsObj(objectArray)
        //                         icp(Date.now())
        //                         console.log("Updated");
        //                     }
        //                 } catch (err) {
        //                     console.log("Malformed response from websocket server", err)
        //                 }
        //             }
        //         }
        //         timer=5000;
        //
        //     } catch (e) {
        //         console.log("Couldnt write to websocket: ", e.toString())
        //         timer=200;
        //     }
        //     if(aa==null) {
        //         saa(setTimeout(async function () {
        //             await getData()
        //         }, timer))
        //     }
        // }

    }

    useEffect(() => {

        // if(lType !== lastType && lastType !== ""){
        //     window.genws.send('{"reqType": "LiveAuctions", "type": "'+lType+'"}');
        //     lastType = lType;
        //     //clearInterval(iv1)
        //     //defInterval = 200;
        // }
        //
        // siv1(aa);

    }, [lType])


    // useEffect(() => {
    //     if (updateSpeed < 15000) {
    //         setUs(15000);
    //         //defInterval = 15000;
    //     } else {
    //         clearInterval(iv1)
    //     }
    //     //   alert(wsObj)
    // }, [wsObj, ic])


    return (
        <div className="container-fluid">
            <div className="col-12 py-0">
                <div className="card card-purple">

                    <div className="card-body p-3">
                        <div className="row">
                            {wsObj && wsObj.map((item, i) => (
                                <> {console.log(item)}
                                    <LiveAuctionsItem
                                        key={i}
                                        item={item}
                                    /></>

                            ))}

                            <div className="col-md-12 text-center">
                                <Link className="btn bg-gradient-dark mb-0" to="/"><ITag
                                    ClassName="fas fa-plus mr-10"/>Load More</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SecLiveAuctions
